import { useEffect } from "react";

const AdBanner = () => {
  useEffect(() => {
    const script1 = document.createElement("script");

    script1.innerHTML = `
      atOptions = {
        'key' : '858b981443ca0e63a55b4725949c96e9',
        'format' : 'iframe',
        'height' : 250,
        'width' : 300,
        'params' : {}
      };
    `;

    const script2 = document.createElement("script");
    script2.src =
      "https://www.highperformanceformat.com/858b981443ca0e63a55b4725949c96e9/invoke.js";
    script2.async = true;

    const container = document.getElementById("adsterra-300x250");

    if (container) {
      container.appendChild(script1);
      container.appendChild(script2);
    }

    return () => {
      if (container) {
        container.innerHTML = "";
      }
    };
  }, []);

  return (
    <div
      id="adsterra-300x250"
      style={{
        width: "300px",
        height: "250px",
        margin: "20px auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    />
  );
};

export default AdBanner;